import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles(() => ({
  tooltipText: {
    fontSize: 10,
  },
  icon: { width: 16, height: 16 },
  button: { textTransform: "none", padding: 0 },
  mainText: {
    color: grey["500"],
    lineHeight: 1.1,
    textDecoration: "underline",
    cursor: "pointer",
  },
}));

export default useStyles;
